import $ from 'jquery';
import { fabric } from 'fabric';
import { modifyState } from '~src/state';
import { toggleEditorSidebar, hideSidebarTab } from '~src/sidebarLegacy';
import { getActiveMagicFrameActive } from '~core/magicFrame';
import editorConfig from '~config/editorConfig';
import { EdgeResizer, loadSvgAsync } from '~src/utils';

export const handleMagicFrameFrameSelection = async (
  url,
  width,
  height,
  svgClip
) => {
  hideSidebarTab('immagini');
  toggleEditorSidebar();
  modifyState('sidebarCurrentBackgroundsTag', editorConfig.magicFrameTag);
  modifyState('magicFrameSelectFramePhotoActive', false);
  const tagId = window.editorConfig.sidebarTags.items.find(
    (tag) => tag.name === editorConfig.magicFrameTag
  );
  $('#select-ricerca-immagini').val(tagId.objectId).trigger('change');

  const magicFrame = getActiveMagicFrameActive();
  if (!magicFrame) {
    return;
  }
  if (svgClip) {
    magicFrame.set({
      width,
      height,
    });
  }
  const resizedImg = new EdgeResizer(url).scaleToWidth(magicFrame.width);
  await magicFrame.updateFrame(resizedImg);

  if (svgClip) {
    const { objects } = await loadSvgAsync(svgClip);
    const firstPath = objects[0];
    magicFrame.clipping = firstPath;
  } else {
    magicFrame.clipping = new fabric.Rect({
      left: 0,
      top: 0,
      width: magicFrame.width,
      height: magicFrame.height,
      fill: 'transparent',
    });
  }

  await magicFrame.updatePerson(magicFrame.getPersonSrc());
  magicFrame.scalePersonToCover();
  window.canvas.renderAll();
};
